module.exports = __webpack_public_path__ + "static/img/cx02.0153226.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cx02.png
// module id = 8Qxk
// module chunks = 0